import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import './styles.css'
import { ContextProvider } from './SocketContext'
import * as serviceWorkerRrgistration from "./serviceWorkerRegistration"

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render( 
    <ContextProvider>
        <App />
    </ContextProvider>
)

serviceWorkerRrgistration.register()